module.exports = __webpack_public_path__ + "static/media/athlete1.22ae49aa.png";